import React from "react";
import s from "./style.module.css";
const EmergenceContent = ({ item }) => {
  return (
    <div className={s.EmergentContainer}>
      <span>{item.label1.text}</span>
      <span> {item.phone}</span>
      <img src={item.emegenceImg} alt="emegenceImg" />
    </div>
  );
};

export default EmergenceContent;
